/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/SOUND_IDS
 *
 * @description
 * ## Internal ID constants
 */


export const SFX_DAMAGE = "sfxDamage";

export const SFX_TWANG_1 = "sfxTwang1";
export const SFX_TWANG_2 = "sfxTwang2";
export const SFX_TWANG_3 = "sfxTwang3";
export const SFX_TWANG_4 = "sfxTwang4";
export const SFX_TWANG_5 = "sfxTwang5";
export const SFX_TWANG_6 = "sfxTwang6";
export const SFX_TWANG_7 = "sfxTwang7";
export const SFX_TWANG_8 = "sfxTwang8";
export const SFX_TWANG_9 = "sfxTwang9";
export const SFX_TWANG_10 = "sfxTwang10";

export const SFX_POP_1 = "sfxPop1";
export const SFX_POP_2 = "sfxPop2";
export const SFX_POP_3 = "sfxPop3";
export const SFX_POP_4 = "sfxPop4";
export const SFX_POP_5 = "sfxPop5";
export const SFX_POP_6 = "sfxPop6";
export const SFX_POP_7 = "sfxPop7";
export const SFX_POP_8 = "sfxPop8";
export const SFX_POP_9 = "sfxPop9";
export const SFX_POP_10 = "sfxPop10";

export const SFX_CLACK_1 = "sfxClack1";
export const SFX_CLACK_2 = "sfxClack2";
export const SFX_CLACK_3 = "sfxClack3";
export const SFX_CLACK_4 = "sfxClack4";
export const SFX_CLACK_5 = "sfxClack5";
export const SFX_CLACK_6 = "sfxClack6";
export const SFX_CLACK_7 = "sfxClack7";
export const SFX_CLACK_8 = "sfxClack8";
export const SFX_CLACK_9 = "sfxClack9";
export const SFX_CLACK_10 = "sfxClack10";

export const SFX_CHOMP_1 = "sfxChomp1";
export const SFX_CHOMP_2 = "sfxChomp2";
export const SFX_CHOMP_3 = "sfxChomp3";
export const SFX_CHOMP_4 = "sfxChomp4";
export const SFX_CHOMP_5 = "sfxChomp5";
export const SFX_CHOMP_6 = "sfxChomp6";
export const SFX_CHOMP_7 = "sfxChomp7";
export const SFX_CHOMP_8 = "sfxChomp8";
export const SFX_CHOMP_9 = "sfxChomp9";
export const SFX_CHOMP_10 = "sfxChomp10";

export const SFX_DROP_1 = "sfxDrop1";
export const SFX_DROP_2 = "sfxDrop2";
export const SFX_DROP_3 = "sfxDrop3";
export const SFX_DROP_4 = "sfxDrop4";
export const SFX_DROP_5 = "sfxDrop5";
export const SFX_DROP_6 = "sfxDrop6";
export const SFX_DROP_7 = "sfxDrop7";
export const SFX_DROP_8 = "sfxDrop8";
export const SFX_DROP_9 = "sfxDrop9";
export const SFX_DROP_10 = "sfxDrop10";
